import React from 'react';
import { IGaugePanel } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import { StorePanelProps } from './StorePanel';
import GaugePanel from '../../../../../../../../theme/ui/Dashboard/GaugePanel/GaugePanel';
import { MultiStoreIcon } from '../../../../../../../../assets/dashboard';
import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';
import useAggregatedDevicesConnectionStatusCount from '../../../../../../../../service/device/CommanderAPI/hooks/useAggregatedDevicesConnectionStatusCount';

function StoreWorkspacesPanel(props: Readonly<StorePanelProps>) {
  const { panel, layout } = props;
  const [t] = useTranslation();
  const {
    isFetching,
    mqttConnected,
    count,
    error: errorDevicesConnectionStatus,
  } = useAggregatedDevicesConnectionStatusCount();

  const gaugePanel: IGaugePanel = {
    ...panel,
    type: 'GAUGE',
    gaugeProps: {
      value: mqttConnected ?? 0,
      valueMax: count ?? 0,
    },
    loading: isFetching,
    icon: <MultiStoreIcon height={'100%'} />,
    labelValueActive: t('dashboard.stores.online'),
    labelValueInactive: t('dashboard.stores.offline'),
  };
  if (errorDevicesConnectionStatus)
    return <Alert severity="error">{t('dashboard.error.fetching')}</Alert>;
  return <GaugePanel panel={gaugePanel} layout={layout} />;
}

export default StoreWorkspacesPanel;
